// extracted by mini-css-extract-plugin
module.exports = {"card":"card_card__QGPxa","title":"card_title__7BIXV","list":"card_list__qw4R8","item":"card_item__ZknaM","name":"card_name__WDx7n","value":"card_value__jHOuX"};